export default [
  {
    title: "Inspectie tehnica periodica",
  },
  {
    title: "Vulcanizare",
  },
  {
    title: "Incarcare freon",
  },
  {
    title: "Climatizare",
  },
  {
    title: "Schimb ulei",
  },
  {
    title: "Asigurare accidente",
  },
]
